// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3kwDg","additionalInfo":"AgreementModal_additionalInfo__24bgF"};